import {
  IOtpSendAndVerify,
  IOtpSendAndVerifyInput,
  IPhoneEnableOtpVerify,
  IPhoneEnableOtpVerifyInput,
} from "./otp.interface";
import { PHONE_ENABLE_OTP_VERIFY, VERIFY_AND_SEND_OTP } from "./otp.mutation";

import { toastMessageActions } from "../../state/request";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useMutation } from "@apollo/client";
import { useRefreshProfile } from "../user-detail/user-detail.service";

// Define the custom hook
export const useSentOtp = () => {
  const dispatch = useDispatch();
  const [
    verifyAndSendOtp,
    { data, loading, error },
  ] = useMutation<{verifyAndSendOtp: IOtpSendAndVerify}>(VERIFY_AND_SEND_OTP);


  const handleSendVerifyOtp = (data: IOtpSendAndVerifyInput) => {
    verifyAndSendOtp(
      { variables: { data: data } },
    );
  };

  useEffect(()=>{
    if (data) {
      dispatch(toastMessageActions.setGlobalAlert({ severity: "success", message: "Code was sent" }));
    }
  }, [data]);

  return {
    handleSendVerifyOtp,
    sendOtpData: data?.verifyAndSendOtp,
    sendOtpLoading: loading,
    sendOtpError: error,
  };
};

type PhoneEnableOtpVerifyResult = { setPhoneForLogin: IPhoneEnableOtpVerify };

export const useOtpVerificaton = () => {
  const refreshProfile = useRefreshProfile();
  const [verifyOtpData, setVerifyOtpData] = useState<PhoneEnableOtpVerifyResult>();
  const [refreshing, setRefreshing] = useState(false);
  const [
    verifyOtp,
    { loading, error: verifyOtpError },
  ] = useMutation<PhoneEnableOtpVerifyResult>(PHONE_ENABLE_OTP_VERIFY);

  // `setPhoneForLogin` writes the phone server-side only; the route guards read
  // the Redux profile, so it is refreshed before the caller is told to proceed.
  const handlePhoneEnableOtpVerify = async (input: IPhoneEnableOtpVerifyInput) => {
    setRefreshing(true);
    try {
      const { data } = await verifyOtp({ variables: { data: input } });

      if (data) {
        await refreshProfile();
        setVerifyOtpData(data);
      }
    } catch {
      // `verifyOtpError` is exposed by useMutation.
    } finally {
      setRefreshing(false);
    }
  };

  return {
    handlePhoneEnableOtpVerify,
    verifyOtpData,
    verifyOtpLoading: loading || refreshing,
    verifyOtpError,
  };
};
